/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * ProjectStopsUnscheduledDtoBase
 * auto generated base class for the model ProjectStopsUnscheduledDtoModel.
 */
export const ProjectStopsUnscheduledDtoModelBase = ModelBase
  .named('ProjectStopsUnscheduledDto')
  .props({
    __typename: types.optional(types.literal("ProjectStopsUnscheduledDto"), "ProjectStopsUnscheduledDto"),
    visitIds: types.union(types.undefined, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ProjectStopsUnscheduledDtoModelSelector extends QueryBuilder {
  get visitIds() { return this.__attr(`visitIds`) }
}
export function selectFromProjectStopsUnscheduledDto() {
  return new ProjectStopsUnscheduledDtoModelSelector()
}

export const projectStopsUnscheduledDtoModelPrimitives = selectFromProjectStopsUnscheduledDto().visitIds
